import React, { memo } from 'react';

import PropTypes from 'prop-types';

import l10n from '../../shared/strings';
import s from './styles.module.scss';

const copy = l10n.PRODUCT_INFO.draftScope;

const DraftScopeDetailsPlaceholder = ({ hasLive = false, onEditText }) => (
  <div className={s.placeholder} data-testid="draft-scope-details-placeholder">
    <div className={s.title}>{copy.mediaOnlyDetailsTitle}</div>
    <div className={s.body}>{copy.mediaOnlyDetails}</div>
    <button
      type="button"
      className={s.editAction}
      data-testid="draft-scope-edit-text"
      onClick={onEditText}
    >
      {hasLive ? copy.manageDraftText : copy.updateFromMaster}
    </button>
  </div>
);

DraftScopeDetailsPlaceholder.propTypes = {
  hasLive: PropTypes.bool,
  onEditText: PropTypes.func,
};

DraftScopeDetailsPlaceholder.defaultProps = {
  hasLive: false,
  onEditText: undefined,
};

export default memo(DraftScopeDetailsPlaceholder);
